import { render, staticRenderFns } from "./MonthlyProfit.vue?vue&type=template&id=015e3dfd&scoped=true"
import script from "./MonthlyProfit.vue?vue&type=script&lang=js"
export * from "./MonthlyProfit.vue?vue&type=script&lang=js"
import style0 from "./MonthlyProfit.vue?vue&type=style&index=0&id=015e3dfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015e3dfd",
  null
  
)

export default component.exports